import React, {useEffect} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {
    bbDoesUserHaveAccessToBreachRiskLevelForEntity,
    bbFindEntityWithinPortfolioOrSelf, bbTranslateBreachRiskScoreToCategory, bbTranslateBreachRiskScoreToColor,
    mapObject
} from "../../../util/bbHelpers";
import PropTypes from "prop-types";
import InfoSharpIcon from "@material-ui/icons/InfoSharp";
import {BRCustomizedTooltip as Tooltip} from "../accents/BRCustomizedTooltip";
import BBDataTable from "../tables/BBDataTable";
// import SummaryTableStepper from "./BRThreatsSummaryTableStepper";
import BBIconCircleFull from "../../../assets/bbCustomIcons/BBIconCircleFull";
import {renderCellExpand} from "../tables/DataGridRenderCellExpand";
import BRThreatsSummaryTableThreatsStatusProgress from "./BRThreatsSummaryTableThreatsStatusProgress";
import {fetchRiskCycleReport} from "../../../actions";
import BBIconBreachRiskScore from "../../../assets/bbCustomIcons/BBIconBreachRiskScore";


const TableContainer = ({   cycleInView=null,
                            portfolioView = false}) => {

    const {customers, customerInView} = useSelector(({customer}) => customer);
    const {entityInView, portfolios, loadingPortfolios, loadingPortfoliosError, loadingCycles, loadingCyclesError} = useSelector(({breachrisk}) => breachrisk);
    const {authUser} = useSelector(({auth}) => auth);

    const customerIdToUse = customers ? customerInView ? customerInView : null : null;
    const customer = customers ? customers[customerIdToUse] : null;

    const dispatch = useDispatch();

    const myEntity = bbFindEntityWithinPortfolioOrSelf(entityInView, portfolios, customerIdToUse);
    // const myEntity = portfolios ? portfolios[customerIdToUse] ? portfolios[customerIdToUse].entities ? selfEntityId ? portfolios[customerIdToUse].entities[selfEntityId] : null : null : null : null;

    const lastCycle = myEntity && myEntity.cycles && myEntity.settings && myEntity.settings.last_cycle_id ? myEntity.cycles[myEntity.settings.last_cycle_id] : null;
    const threatVectors = lastCycle ? lastCycle.vectors : null;
    const totalNumThreatVectors = threatVectors ? Object.keys(threatVectors).length : null;

    const isUserAllowedToSeeDataInThisTable = bbDoesUserHaveAccessToBreachRiskLevelForEntity(authUser, "infoLevel2", entityInView);
    // console.log("Is user allowed to see data in this table?", isUserAllowedToSeeDataInThisTable)

    // console.log("last cycle ", lastCycle, "threatVectors", threatVectors, "totalNumThreatVectors", totalNumThreatVectors);

    //cycle data if cycleInView is passed prop
    const pastReportView = cycleInView && lastCycle && cycleInView !== lastCycle.id;

    useEffect(()=>{
        if(pastReportView){
            if (cycleInView && myEntity && myEntity.cycles && !myEntity.cycles[cycleInView]) {
                dispatch(fetchRiskCycleReport({
                    customerId: customerIdToUse,
                    cycleId: cycleInView
                }))
            }
        }
    }, [cycleInView])

    const cycleToUsePRV = pastReportView && myEntity && myEntity.cycles && myEntity.cycles[cycleInView] ? myEntity.cycles[cycleInView] : null;
    const threatVectorsPRV = cycleToUsePRV && cycleToUsePRV.vectors ? cycleToUsePRV.vectors : null;
    const totalNumThreatVectorsPRV = threatVectorsPRV ? Object.keys(threatVectorsPRV).length : null;

    const vectorsToUse = !pastReportView ? threatVectors
                        : threatVectorsPRV ? threatVectorsPRV
                        : null;

    /**************************/
  /*End Setup State and Dispatch*/
  /**************************/

    const title = <div className={""} id={"tourThreartsSummaryTable"}>
        Summary of All Threats <Tooltip title={"Summary of distinct types of pathways to cause a breach, along with threat status and Danger Rating. This list displays only one item for each type, but there could be multiple pathways for each item shown."}>
            <InfoSharpIcon style={{fontSize: "smaller"}} className={``}/>
        </Tooltip>
    </div>;

    const getThreatStatus = (stepStatus)=> {
        let status;
        switch (stepStatus) {
            case 0 :
                status = "Identified";
                break;
            case 1:
                status = "Verified";
                break;
            case 2:
                status = "Tested";
                break;
            case 3:
                status = "Breached";
                break;
            default:
                status = "N/A";
        }
        return status
    }


//TODO: EXport is bad in ways I do not understand
  const userTableHeadings = [
      { field: 'riskCategory', headerName: 'Danger Level', disableExport: false,
          renderHeader: (params) => <Tooltip title={"Risk Level, corresponding to the Risk Chart."}>
              <span><BBIconCircleFull/></span>
          </Tooltip>,
          hide: false, sortable: true, type: 'string', width : 45,
          renderCell: (params) => {
              return <Tooltip title={`${params.value}`}>{params.row.colorDot}</Tooltip>
          }},

      { field: 'name', headerName: 'Threat Type', hide: false, sortable: true, type: 'string', flex : 2, cellClassName: "threat_type_summary",
          renderCell: (params) =>
          renderCellExpand(params,
              (<Tooltip title={params.row.typeDescription ? `${params.row.typeDescription}` : null }>
                          <span>
                              {params.value}
                          </span>
              </Tooltip>
        ))},
      { field: 'threatStatus', headerName: 'Threat Status', hide: false, sortable: true, type: 'string', width : 220,
          renderCell: (params) =>

              (<Tooltip title={``}>
                      <span>
                          <BRThreatsSummaryTableThreatsStatusProgress currentStep={params.row.stepNumber}/>
                      </span>
              </Tooltip>)

      },
      { field: 'score', headerName: 'Danger Level', hide: false, sortable: true, type: 'string', width : 85,
          renderHeader: params =>
              <Tooltip  heading={"Danger Level is the individual threat level applied to this vector. Ranges from 0 - 10 with higher numbers being more dangerous."} title={"Danger Level"}><span><BBIconBreachRiskScore/></span></Tooltip>
          ,
          renderCell: (params) => {

                  return<span>
                              {params.value}<small> /10</small>
                          </span>


          }},

  ];

    //peel the state data into a form the dataTable can read
  const tableData = vectorsToUse ? mapObject(vectorsToUse, (key, vector) => {
      const dot = <path d="m86 50c0 19.883-16.117 36-36 36s-36-16.117-36-36 16.117-36 36-36 36 16.117 36 36"/>
      const color = bbTranslateBreachRiskScoreToColor(vector.score, true)

      const getThreatStepNumber = (vector)=> {
          let currentStep;
          if (vector.is_breached) {
              return currentStep = 3;
              // "One or more attacks have been successful. This means this threat is open to possible exploitation by hackers. Action is required."
          } else if (vector.is_tested) {
              return currentStep = 2;
              // "Attack actions against this threat are taking place. We will report whether your current defenses are able to stop the testing attacks."
          } else if (vector.is_validated) {
              return currentStep = 1;
              // "Preliminary findings indicate that this threat could be a potential point of attack. Next the threat will be tested and proved."
          } else if (vector.is_discovered) {
              return currentStep = 0;
              // "This threat was identified as a possible attack vector. Next the threat will be verified, tested, and proved."}
          } else {
              return currentStep = 4;
              // "Status Pending..."
          }
      }

              return (
        {
            customerId: customer.CustomerId,
            id: key,
            name: vector.definition.name,
            categoryId: vector.definition.id,
            service: vector.definition.service,
            typeId: vector.definition.type.id,
            typeName: vector.definition.type.name,
            typeDescription: vector.definition.type.description,
            cycle: vector.cycle,
            impact_score: vector.impact_score,
            likelihood_score: vector.likelihood_score,
            score: parseFloat(vector.score).toFixed(1),
            status: vector.status,
            stepNumber: getThreatStepNumber(vector),
            threatStatus: getThreatStatus(getThreatStepNumber(vector)),
            is_discovered: vector.is_discovered,
            is_validated: vector.is_validated,
            is_tested: vector.is_tested,
            is_breached: vector.is_breached,
            riskCategory: bbTranslateBreachRiskScoreToCategory(vector.score),
            colorDot: <svg x={-10} y={-10} width={25} height={25} fill={color} viewBox="0 0 100 100">{dot}</svg>

        }
    )
  }) : null;

    const tableDataAsArray = () => {
        // console.log("Creating humansTableData as array from humanTableData ", tableData);
        let arr=[];
        for (let ob in tableData) {
            // console.log("ob is ", tableData[ob])
            arr.push(tableData[ob]);
        }
        // console.log("resulting array ", arr);
        return arr;
    }

    console.log(threatVectors, tableDataAsArray())


    return (
        <div >
            {((threatVectors || totalNumThreatVectors === 0 || threatVectorsPRV || totalNumThreatVectorsPRV || !isUserAllowedToSeeDataInThisTable)
                && myEntity
                && myEntity.settings
                && customerIdToUse
                && !loadingPortfoliosError[customerIdToUse]
                && !loadingPortfolios[customerIdToUse]
                && !loadingCycles[myEntity.settings.last_cycle_id]
                && !loadingCyclesError[myEntity.settings.last_cycle_id]

            ) ?

                <BBDataTable
                    portfolioTrial = {portfolioView}
                    subscriptionNameOrId={portfolioView ? "BRP" : "BRfB"}
                    elementDisplayNameForConsoleLogs={`BRThreatsSummaryTable ${portfolioView ? "(BRP View)" : "(BRfB View)"}`}
                    columns={userTableHeadings}
                    rows={tableDataAsArray()}
                    totalRows={totalNumThreatVectors}
                    progressValue={threatVectors ? Object.keys(threatVectors).length / totalNumThreatVectors * 100 : isUserAllowedToSeeDataInThisTable ? 0 : 100}
                    // bufferValue={willBeDoneLocalPagewiseLoadingWhenTargetsIs ? willBeDoneLocalPagewiseLoadingWhenTargetsIs / totalNumTargets * 100 : 0}
                    title={title}
                    enableExport
                    loading={false}
                    // requiresModule={"monitor"}
                    requiresBRLevel = {"infoLevel2"}
                    customer={customer}
                    authUser = {authUser}
                    entityId = {entityInView}
                    portfolioView={portfolioView}
                    // topRightElement={<BBModuleIcon includeTooltip module={bbGetModulePropertyFromIdOrName("monitor", "id")} isActive={bbDoesCustomerHaveAccessToModule(customer, "monitor")} iconSize={"40px"}/>}
                    defaultSortModel = {[
                        {
                            field: 'score',
                            sort: 'desc',
                        },
                        {
                            field: 'name',
                            sort: 'asc',
                        }

                    ]}
                    rowsPerPageOptions = {[3, 5, 10, 25]}
                    defaultPageSize = {3}
                    // trial
                />
            :
            <BBDataTable
                portfolioTrial = {portfolioView}
                subscriptionNameOrId={portfolioView ? "BRP" : "BRfB"}
                columns={userTableHeadings}
                rows={[]}
                title={title}
                loading = {true}
                progressValue={0}
                bufferValue={0}
                rowsPerPageOptions = {[3, 5, 10, 25]}
                defaultPageSize = {3}
                // trial
            />
            }
        </div>
    );



}
TableContainer.propTypes = {
    customerId: PropTypes.string,
};

export default TableContainer